import type { JSONDocNode } from '@atlaskit/editor-json-transformer/types';

/**
 * Checks if a JSONDocNode contains a Rovo skill inline extension.
 * Used to determine if the prompt input has a prefilled skill chip.
 */
export function hasRovoSkillInDoc(doc: JSONDocNode | undefined): boolean {
	return Boolean(
		doc?.content?.some(
			(block) =>
				'content' in block &&
				Array.isArray(block.content) &&
				block.content.some(
					(node) =>
						node != null &&
						node?.type === 'inlineExtension' &&
						(node as { attrs?: { extensionType?: string } })?.attrs?.extensionType ===
							'com.atlassian.rovo.skill',
				),
		),
	);
}
